<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Failure"
      />
      <h1>
        Failure
      </h1>
      <p>
        Payment failed, please try again.
      </p>
      <Button
        title="Pay"
        @click="payRedirect()"
      />
    </VerticalNavigator>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import ErrorModal from "@/components/modals/error.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {onBeforeMount, ref} from "vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import Button from "@/components/button.vue"
  import router from "@/router"

  const error = ref<Error>(null)
  const orderID = ref<string>(null)

  onBeforeMount(() => {
    orderID.value = useRoute().params.orderID.toString()
  })

  function payRedirect() {
    router.push({
      name: "pay_payment",
      params: {
        orderID: orderID.value
      }
    })
  }
</script>
